<template>
    <div class="pages">
        <!-- 快捷栏 -->
        <shortcut-bar class="shortcut-bar page-header" />
        <div class="page-header-placeholder"></div>

        <div class="box">
            <div class="boxBreadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">{{ $t('首页') }}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/user-center/2/after-sale' }">{{ $t('退款/售后')
                        }}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ $t('订单详情') }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="box-box" :class="{ 'is-h5': isH5 }">

                <div class="form-row align-center margin-bottom-20">
                    <div class="box-tit box-tit-box">{{ $t('退款商品') }}</div>
                    <div class="form-row-content">
                        <div class="box-xinxi text-14 box-xinxi-wrap">
                            <img :src="refund_detail.product_image" alt="" class="xinxi-img">
                            <div class="justify-between flex-direction box-xinxi-content">
                                <div>
                                    <div class="margin-bottom-8">{{ refund_detail.product_title }}</div>
                                    <div class="text-999">{{ refund_detail.product_sku_text }}</div>
                                </div>
                                <div class="text-22 text-85674B">￥{{ refund_detail.product_price }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-row align-center margin-bottom-20">
                    <div class="box-tit box-tit-box">{{ $t('售后类型') }}</div>
                    <div>{{ refund_detail.type == 'refund' ? $t('仅退款') : $t('退货退款') }}</div>
                </div>

                <div class="form-row align-center margin-bottom-24">
                    <div class="box-tit"><span class="text-fd3b00">*</span>{{ $t('退款原因') }}</div>
                    <div class="box-txt">{{ refund_detail.reason }}</div>
                </div>

                <div class="form-row align-center margin-bottom-24">
                    <div class="box-tit"><span class="text-fd3b00">*</span>{{ $t('退款金额') }}</div>
                    <div class="box-txt">
                        {{ (refund_detail.product_price * refund_detail.product_num).toFixed(2) }}
                    </div>
                </div>

                <div class="form-row align-center margin-bottom-24" v-if="refund_detail.content">
                    <div class="box-tit box-tit-box">{{ $t('退款说明') }}</div>
                    <div class="box-textarea">{{ refund_detail.content }}</div>
                </div>

                <div class="form-row align-center margin-bottom-24" v-if="images.length">
                    <div class="box-tit box-tit-box">{{ $t('上传照片') }}</div>
                    <div class="box-upload">
                        <div>
                            <img :src="item" alt="" v-for="(item, index) in images">
                        </div>
                        <div class="box-upload-txt">{{ $t('上传凭证最多9张') }}</div>
                    </div>
                </div>

                <div class="order-step-wrap">
                    <ShoppingProcess :list="stepList" :indexValue="indexValue" />
                </div>

                <div class="message">
                    <!-- <div class="message-box" v-if="aftersale_status == 1">
                        <p class="margin-bottom-16 text-16">当前状态：请等待商家处理</p>
                        <div class="message-btn btn-61AC85" @click="refund_show = true">取消售后</div>
                    </div> -->
                    <div class="message-box" v-if="aftersale_status == 4">
                        <p class="text-16">{{ $t('当前状态：商家已同意退款，金额将原路返回') }}</p>
                    </div>
                    <div class="message-box" v-if="aftersale_status == -1">
                        <p class="margin-bottom-16 text-16">{{ $t('当前状态：商家已拒绝退款') }}</p>
                        <p class="text-16">{{ $t('拒绝原因：') }}{{ refund_detail.refund_msg }}</p>
                    </div>
                    <div class="message-box" v-if="aftersale_status == -2">
                        <p class="text-16">{{ $t('当前状态：售后取消') }}</p>
                    </div>
                    <div class="message-box" v-if="aftersale_status == 2">
                        <div class="margin-bottom-24 text-16">
                            {{ $t('当前状态：买家已退货，待卖家收到货后确认退货') }}
                        </div>
                        <div class="margin-bottom-24 text-999 text-14">
                            {{ $t('商家收货地址：') }}{{ aftersale_data.back_user_address }} {{ aftersale_data.back_user_name
                            }}
                            {{ aftersale_data.back_user_mobile }}
                        </div>
                        <div class="express-row align-center margin-bottom-16">
                            <p class="margin-right-24 text-16">{{ $t('选择快递') }}</p>
                            <el-select v-model="reason" filterable remote reserve-keyword :placeholder="$t('请选择')"
                                :remote-method="remoteMethod" :loading="loading" class="express-select"
                                @change="changeSelect">
                                <el-option v-for="(item, index) in options" :key="index" :label="item.name"
                                    :value="item.code"></el-option>
                            </el-select>
                        </div>
                        <div class="express-row align-center">
                            <p class="margin-right-24 text-16">{{ $t('快递单号') }}</p>
                            <input type="text" :placeholder="$t('请输入')" class="message-box-ipt"
                                v-model="refund_data.back_express_no">
                        </div>

                        <div class="message-box-btn" v-if="!isH5">
                            <div class="btn-l" @click="onSendBack(0)">{{ $t('撤销售后') }}</div>
                            <div class="btn-r" @click="onSendBack(1)">{{ $t('提交') }}</div>
                        </div>
                    </div>
                    <div class="message-box" v-if="aftersale_status == 3">
                        <p class="text-16">{{ $t('当前状态：买家已寄回等待卖家收货') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 取消售后 -->
        <popup :show="refund_show" :content="$t('确定取消此商品售后申请吗？')" @close="refund_show = false"
            @confirm="onRefundConfirm">
        </popup>
        <!-- 确认提交快递信息 -->
        <popup :show="submit_show" :content="$t('确定提交吗？')" @close="submit_show = false" @confirm="onSubmitConfirm">
        </popup>

        <!-- H5 底部操作栏（退货寄回） -->
        <div class="h5-action-bar" v-if="isH5 && aftersale_status == 2">
            <div class="h5-btn h5-btn-cancel" @click="onSendBack(0)">{{ $t('撤销售后') }}</div>
            <div class="h5-btn h5-btn-primary" @click="onSendBack(1)">{{ $t('提交') }}</div>
        </div>

        <footer-bar></footer-bar>
    </div>
</template>

<script>
import ShortcutBar from '@/components/ShortcutBar'
import ShoppingProcess from '../order/components/ShoppingProcess.vue';
import popup from '../../components/popup.vue';
import { getToken } from "@/utils/auth";
import { refundDetail, refundCause, cancelRefund, courierServicesCompany, returnAfterSale, getconf } from '@/api/user';
import footerBar from '@/components/footerBar';

export default {
    name: 'UserCenter',
    components: {
        'shortcut-bar': ShortcutBar,
        'footer-bar': footerBar,
        ShoppingProcess,
        popup,
    },
    data() {
        return {
            id: '',//订单id
            type: '',//退款方式
            headers: {},//图片上传的请求头
            images: [],//图片
            stepList: [],//步骤条
            indexValue: '0',//步骤条位置

            refund_detail: {},//退款详情
            aftersale_status: '',//售后状态
            refund_show: false,//取消售后确认弹窗
            submit_show: false,//提交弹窗

            options: [],//快递公司
            reason: '',//选择的快递
            loading: false,//搜索加载
            list: [],//快递公司储存数组

            refund_data: {
                id: '',//售后记录ID
                back_express_id: '',//快递公司ID
                back_express_code: '',//快递公司编码
                back_express_name: '',//快递公司名称
                back_express_no: '',//运单号
            },//售后寄回参数

            aftersale_data: {},//退款信息
            isH5: typeof window !== 'undefined' && window.innerWidth < 768,
        }
    },
    computed: {

    },
    mounted() {
        this.updateIsH5();
        window.addEventListener('resize', this.updateIsH5);
        this.id = this.$route.params.id;
        this.refund_data.id = this.id
        this.onDetail()
        this.onCourierServicesCompany()
        this.onGetconf()
        this.headers = {
            'user-token': getToken()
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateIsH5);
    },
    methods: {
        updateIsH5() {
            this.isH5 = window.innerWidth < 768;
        },
        /**获取配置 */
        onGetconf() {
            getconf({ module: 'aftersale' }).then(res => {
                console.log(res.data);
                this.aftersale_data = res.data
            })
        },
        /**确定提交 */
        onSubmitConfirm() {
            returnAfterSale(this.refund_data).then(res => {
                if (res.code == 1) {
                    this.$message.success(this.$t('已提交'));
                    this.onDetail()
                } else {
                    this.$message.warning(res.msg);
                }
                this.submit_show = false
            })
        },
        /**快递退回或撤销售后 */
        onSendBack(i) {
            if (i == 0) {
                this.refund_show = true
            } else {
                if (!this.refund_data.back_express_id) {
                    this.$message(this.$t('请选择快递'));
                    return
                }
                if (!this.refund_data.back_express_no) {
                    this.$message(this.$t('请输入快递单号'));
                    return
                }
                this.submit_show = true
            }
        },
        //搜索快递
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.options = this.list.filter(item => {
                        return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options = [];
            }
        },
        /**选中值变化时触发 */
        changeSelect(e) {
            this.list.filter(item => {
                if (item.code == e) {
                    this.refund_data.back_express_id = item.id
                    this.refund_data.back_express_code = item.code
                    this.refund_data.back_express_name = item.name
                }
            });
        },
        /**快递公司 */
        onCourierServicesCompany() {
            courierServicesCompany().then(res => {
                this.options = res.data
                this.list = res.data
            })
        },
        /**确认取消售后 */
        onRefundConfirm() {
            cancelRefund({ id: this.id }).then(res => {
                if (res.code == 1) {
                    this.$message.success(this.$t('已取消售后申请'));
                    setTimeout(ress => {
                        this.$router.push({ name: 'AfterSale', params: { type: 2 } });
                    }, 1000)
                } else {
                    this.$message.warning(res.msg);
                }
                this.refund_show = false
            })
        },
        /**退款详情 */
        onDetail() {
            refundDetail({ id: this.id }).then(res => {
                this.refund_detail = res.data
                this.aftersale_status = res.data.aftersale_status
                this.images = res.data.images.split(',')
                if (this.refund_detail.type == 'refund') {
                    this.stepList = [
                        { txt: this.$t('买家申请退款'), value: '1' },
                        { txt: this.$t('商家处理退款申请'), value: '2' },
                        { txt: this.$t('售后结果'), value: '3' }
                    ]
                    if (this.aftersale_status == 1) {
                        this.indexValue = 1
                    } else if (this.aftersale_status == 4 || this.aftersale_status == -1 || this.aftersale_status == -2) {
                        this.indexValue = 2
                    }
                } else {
                    this.stepList = [
                        { txt: this.$t('买家申请退款'), value: '1' },
                        { txt: this.$t('商家处理退款申请'), value: '2' },
                        { txt: this.$t('买家退货'), value: '3' },
                        { txt: this.$t('售后结果'), value: '4' }
                    ]
                    if (this.aftersale_status == 1) {
                        this.indexValue = 1
                    } else if (this.aftersale_status == 2 || this.aftersale_status == 3) {
                        this.indexValue = 2
                    } else if (this.aftersale_status == 4 || this.aftersale_status == -1 || this.aftersale_status == -2) {
                        this.indexValue = 3
                    }
                }
                // this.onRefundCause()
            })
        },
        /**退款原因 */
        onRefundCause() {
            refundCause({ type: 'refund' }).then(res => {
                console.log(this.refund_detail);
                let list = res.data
                list.forEach(e => {
                    console.log(e);
                })
            })
        },
        /**图片上传 */
        handleAvatarSuccess(res, file, fileList) {
            this.images = []
            fileList.forEach(item => {
                this.images.push(item.response.data.url)
            })
        },
        /**图片移除 */
        handleRemove(file, fileList) {
            // console.log(file.response.data.url, fileList);
            this.images = []
            fileList.forEach(item => {
                this.images.push(item.response.data.url)
            })
        },
    }
};
</script>

<style scoped lang="scss">
.page-header {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}

.page-header-placeholder {
    height: 56px;
}

.box {
    padding: 0 var(--page-gutter-wide);
}

/*面包屑*/
.boxBreadcrumb {
    padding: 24px 0 32px 0;
}

/**订单内容 */
.box-box {
    /* // padding: 32px; */
    background: #FFFFFF;
    border-radius: 8px;
    /* // height: calc(100vh - 200px); */
    overflow: auto;
    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 32px 24px;
    margin-bottom: 80px;

    .box-tit {
        font-size: 16px;
        color: #999999;
        margin-right: 24px;
    }

    .box-tit-box {
        margin-left: 4px;
    }

    .box-txt {
        width: 480px;
        height: 38px;
        line-height: 38px;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        padding-left: 15px;
        font-size: 14px;
        box-sizing: border-box;
    }

    .box-textarea {
        padding: 8px 15px;
        font-size: 14px;
        width: 480px;
        height: 95px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #DCDFE6;
        box-sizing: border-box;
    }

    /**商品 */
    .box-xinxi-wrap {
        width: 560px;
    }

    .box-xinxi-content {
        width: calc(100% - 136px);
    }

    .box-xinxi {
        display: flex;
        margin-bottom: 12px;

        .xinxi-img {
            width: 120px;
            height: 120px;
            border-radius: 8px;
            margin-right: 16px;
            object-fit: cover;
            object-position: center;
            flex-shrink: 0;
        }
    }

    .box-xinxi:last-child {
        margin-bottom: 0;
    }

    .box-upload {
        width: calc(100% - 92px);

        img {
            width: 80px;
            height: 80px;
            margin-right: 12px;
            margin-bottom: 12px;
            border-radius: 8px;
        }
    }

    .box-upload-txt {
        font-size: 16px;
        color: #999999;
        margin-top: 12px;
    }

    .order-step-wrap {
        padding-top: 32px;
        border-top: 1px solid #CCCCCC;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
    }

    .express-select {
        width: 320px;
    }

    .box-btn {
        width: 160px;
        height: 42px;
        background: #61AC85;
        border-radius: 8px;
        font-size: 16px;
        color: #FFFFFF;
        font-weight: bold;
        text-align: center;
        line-height: 42px;
        margin-left: calc(120px - 32px);
        cursor: pointer;
    }
}

/**信息 */
.message {
    padding: 40px 0 0;
    /* // border-bottom: 1px solid #CCCCCC; */

    .message-box {
        display: flex;
        flex-direction: column;
        align-items: center;

        .message-box-ipt {
            width: 320px;
            height: 38px;
            border-radius: 4px;
            border: 1px solid #CCCCCC;
            box-sizing: border-box;
            padding: 0 30px 0 15px;
        }

        .message-btn {
            width: 160px;
            height: 40px;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 14px;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
        }

        .btn-61AC85 {
            background: #61AC85;
        }

        .message-box-btn {
            display: flex;
            align-items: center;
            margin-top: 24px;

            div {
                width: 160px;
                height: 40px;
                font-size: 14px;
                text-align: center;
                line-height: 40px;
                box-sizing: border-box;
                border-radius: 4px;
                margin: 0 24px;
                cursor: pointer;
            }

            .btn-l {
                border: 1px solid #CCCCCC;
                color: #333333;
            }

            .btn-r {
                background: #61AC85;
                color: #FFFFFF;
            }
        }
    }
}

@media (max-width: 767px) {
    .pages {
        overflow-x: hidden;
        width: 100%;
        background: #f5f6f8;
        padding-bottom: calc(72px + env(safe-area-inset-bottom, 0px));
    }

    .page-header {
        padding-top: env(safe-area-inset-top, 0px);
    }

    .page-header-placeholder {
        height: calc(56px + env(safe-area-inset-top, 0px));
    }

    .box {
        padding: 0 12px 24px;
        box-sizing: border-box;
    }

    .boxBreadcrumb {
        padding: 10px 0 12px;
        overflow-x: auto;
        white-space: nowrap;
        font-size: 12px;
    }

    .box-box.is-h5 {
        background: transparent;
        border-radius: 0;
        box-shadow: none;
        padding: 0;
        margin-bottom: 0;
        overflow: visible;
        display: flex;
        flex-direction: column;
        gap: 12px;

        .form-row {
            flex-direction: column;
            align-items: stretch;
            margin-bottom: 0;
            background: #fff;
            border-radius: 8px;
            padding: 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
            box-sizing: border-box;
        }

        .box-tit {
            margin-right: 0;
            margin-bottom: 10px;
            font-size: 14px;
            color: #666;
        }

        .box-tit-box {
            margin-left: 0;
        }

        .form-row-content {
            width: 100%;
        }

        .box-txt {
            width: 100%;
        }

        .box-textarea {
            width: 100%;
            height: auto;
            min-height: 60px;
        }

        .box-xinxi-wrap {
            width: 100%;
        }

        .box-xinxi-content {
            width: calc(100% - 92px);
            min-width: 0;
        }

        .box-xinxi {
            margin-bottom: 0;

            .xinxi-img {
                width: 80px;
                height: 80px;
                flex-shrink: 0;
                object-fit: cover;
                margin-right: 12px;
            }

            .text-22 {
                font-size: 18px;
            }
        }

        .box-upload {
            width: 100%;

            img {
                width: 72px;
                height: 72px;
                margin-right: 8px;
                margin-bottom: 8px;
                object-fit: cover;
            }
        }

        .box-upload-txt {
            font-size: 13px;
            margin-top: 8px;
        }

        .order-step-wrap {
            padding-top: 0;
            border-top: none;
            background: #fff;
            border-radius: 8px;
            padding: 12px 8px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
            overflow-x: auto;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        /deep/ .order-step-wrap .step {
            min-width: fit-content;
        }

        /deep/ .order-step-wrap .step .step-list .list-box {
            font-size: 12px;
        }

        .express-select {
            width: 100%;
        }

        /deep/ .express-select .el-input {
            width: 100%;
        }
    }

    .message {
        padding: 0;

        .message-box {
            background: #fff;
            border-radius: 8px;
            padding: 16px 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
            align-items: stretch;
            text-align: left;

            .text-16 {
                font-size: 14px;
                line-height: 1.6;
            }

            .text-14 {
                font-size: 13px;
                line-height: 1.6;
            }

            .margin-bottom-24 {
                margin-bottom: 12px;
            }

            .margin-bottom-16 {
                margin-bottom: 12px;
            }

            .express-row {
                flex-direction: column;
                align-items: stretch;
                width: 100%;

                p {
                    margin-right: 0;
                    margin-bottom: 8px;
                }
            }

            .message-box-ipt {
                width: 100%;
            }
        }
    }

    .h5-action-bar {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 998;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
        background: #fff;
        box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
        box-sizing: border-box;

        .h5-btn {
            flex: 1;
            height: 44px;
            line-height: 44px;
            border-radius: 8px;
            font-size: 15px;
            text-align: center;
            cursor: pointer;
            box-sizing: border-box;
            transition: transform 0.15s ease, opacity 0.15s ease;
        }

        .h5-btn:active {
            transform: scale(0.98);
            opacity: 0.88;
        }

        .h5-btn-cancel {
            background: #fff;
            border: 1px solid #ccc;
            color: #333;
        }

        .h5-btn-primary {
            background: #61AC85;
            color: #fff;
            border: none;
        }
    }
}
</style>

<style>
.box-upload .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 92px;
}

.box-upload .el-upload-list__item {
    width: 80px;
    height: 80px;
    line-height: 92px;
}
</style>



// WEBPACK FOOTER //
// src/view/afterSale/RefundDetail.vue